/**
向local中存储数据的工具模块
1. 向外暴露一个函数(功能)
   只有一个功能需要暴露
2. 向外暴露一个对象(包含多个功能)
   有多个功能需要暴露
 **/
import Cookie from "js-cookie";
import Encrypt from "@/plugins/encrypt";
const TODOS_KEY = "m-userCenter";
const PAGETYPE = "pageType";
const ALTFLAVORS = "altFlavors";
const VERSION = "version";
const SOURCETYPE = "sourceType";
const TOKEN = "token";
const TOKENCOOKIE = "tokenCookie";
const CUSTOMERNUMBER = "customerNumber";
const ASTERISK = "asterisk";
const ACCOUNTNO = "accountNo";
const PLATFORM = "platform";
const PLATFORMNAME = "platformName";
const ACCOUNTINFO = "accountInfo";
const CURRENCY = "currency";
const RECHAREDATA = "rechargeData";
const WITHDRAWALDATA = "withdrawalData";
const TRANSFERDATA = "transferData";
const GTS2CUSTOMERID = "gts2CustomerId";
const GTS2ACCOUNTID = "gts2AccountId";
const TABINDEX = "tabIndex";
const TIMEDATA = "timeData";
const PAYSWITCHSTATUS = "paySwitchStatus";
const TRADECONDITION = "tradeCondition";
const ENTRUSTCONDITION = "entrustCondition";
const PROFITANDLOSSCONDITION = "profitAndLossCondition";
const CREDITCONDITION = "creditCondition";
const STOPCONDITION = "stopCondition";
const KEEPALIVE = "keepAlive";
const TICKDATA = "tickData";
export default {
  readUser() {
    return JSON.parse(Encrypt.get(Cookie.get(TODOS_KEY)) || "{}");
  },
  saveUser(user) {
    const expiresTime = 60 * 1000 * 60 * 2; // 过期时间
    const millisecond = new Date().getTime();
    const date = new Date(millisecond + expiresTime);
    Cookie.set(TODOS_KEY, Encrypt.set(JSON.stringify(user)), {
      expires: date,
      path: "/",
    });
  },
  readAltFlavors() {
    return JSON.parse(localStorage.getItem(ALTFLAVORS));
  },
  saveAltFlavors(altFlavors) {
    localStorage.setItem(ALTFLAVORS, JSON.stringify(altFlavors))
  },
  readPageType() {
    return JSON.parse(localStorage.getItem(PAGETYPE));
  },
  savePageType(pageType) {
    localStorage.setItem(PAGETYPE, JSON.stringify(pageType));
  },
  readVersion() {
    return JSON.parse(localStorage.getItem(VERSION));
  },
  saveVersion(version) {
    localStorage.setItem(VERSION, JSON.stringify(version));
  },
  readSourceType() {
    return JSON.parse(localStorage.getItem(SOURCETYPE));
  },
  saveSourceType(sourceType) {
    localStorage.setItem(SOURCETYPE, JSON.stringify(sourceType));
  },
  readToken() {
    return JSON.parse(localStorage.getItem(TOKEN));
  },
  saveToken(token) {
    localStorage.setItem(TOKEN, JSON.stringify(token));
  },
  readTokenCookie() {
    return JSON.parse(Cookie.get(TOKENCOOKIE) || "{}");
  },
  saveTokenCookie(tokenCookie) {
    const expiresTime = 60 * 1000 * 60 * 2; // 过期时间
    const millisecond = new Date().getTime();
    const date = new Date(millisecond + expiresTime);
    Cookie.set(TOKENCOOKIE, JSON.stringify(tokenCookie), {
      expires: date,
      path: "/",
    });
  },
  readCustomerNumber() {
    return localStorage.getItem(CUSTOMERNUMBER);
  },
  saveCustomerNumber(customerNumber) {
    localStorage.setItem(CUSTOMERNUMBER, JSON.stringify(customerNumber));
  },
  readAsterisk() {
    return localStorage.getItem(ASTERISK);
  },
  saveAsterisk(asterisk) {
    localStorage.setItem(ASTERISK, JSON.stringify(asterisk));
  },
  saveAccountNo(accountNo) {
    localStorage.setItem(ACCOUNTNO, Encrypt.set(JSON.stringify(accountNo)));
  },
  readAccountNo() {
    return JSON.parse(Encrypt.get(localStorage.getItem(ACCOUNTNO)));
  },
  readPlatform() {
    return JSON.parse(Encrypt.get(localStorage.getItem(PLATFORM)));
  },
  savePlatform(platform) {
    localStorage.setItem(PLATFORM, Encrypt.set(JSON.stringify(platform)));
  },
  readPlatformName() {
    return JSON.parse(Encrypt.get(localStorage.getItem(PLATFORMNAME)));
  },
  savePlatformName(platformName) {
    localStorage.setItem(
      PLATFORMNAME,
      Encrypt.set(JSON.stringify(platformName))
    );
  },
  readAccountInfo() {
    return JSON.parse(Encrypt.get(localStorage.getItem(ACCOUNTINFO)));
  },
  saveAccountInfo(accountInfo) {
    localStorage.setItem(ACCOUNTINFO, Encrypt.set(JSON.stringify(accountInfo)));
  },
  readCurrency() {
    return JSON.parse(Encrypt.get(localStorage.getItem(CURRENCY)));
  },
  saveCurrency(currency) {
    localStorage.setItem(CURRENCY, Encrypt.set(JSON.stringify(currency)));
  },
  readRechargeData() {
    return JSON.parse(Encrypt.get(localStorage.getItem(RECHAREDATA)));
  },
  saveRechargeData(rechargeData) {
    localStorage.setItem(
      RECHAREDATA,
      Encrypt.set(JSON.stringify(rechargeData))
    );
  },
  readWithdrawalData() {
    return JSON.parse(Encrypt.get(localStorage.getItem(WITHDRAWALDATA)));
  },
  saveWithdrawalData(withdrawalData) {
    localStorage.setItem(
      WITHDRAWALDATA,
      Encrypt.set(JSON.stringify(withdrawalData))
    );
  },
  readTransferData() {
    return JSON.parse(Encrypt.get(localStorage.getItem(TRANSFERDATA)));
  },
  saveTransferData(transferData) {
    localStorage.setItem(
      TRANSFERDATA,
      Encrypt.set(JSON.stringify(transferData))
    );
  },
  readGts2CustomerId() {
    return JSON.parse(Encrypt.get(localStorage.getItem(GTS2CUSTOMERID)));
  },
  saveGts2CustomerId(gts2CustomerId) {
    localStorage.setItem(
      GTS2CUSTOMERID,
      Encrypt.set(JSON.stringify(gts2CustomerId))
    );
  },
  readGts2AccountId() {
    return JSON.parse(Encrypt.get(localStorage.getItem(GTS2ACCOUNTID)));
  },
  saveGts2AccountId(gts2AccountId) {
    localStorage.setItem(
      GTS2ACCOUNTID,
      Encrypt.set(JSON.stringify(gts2AccountId))
    );
  },
  readTabIndex() {
    return localStorage.getItem(TABINDEX);
  },
  saveTabIndex(tabIndex) {
    localStorage.setItem(TABINDEX, JSON.stringify(tabIndex));
  },
  readTimeData() {
    return JSON.parse(localStorage.getItem(TIMEDATA));
  },
  saveTimeData(timeData) {
    localStorage.setItem(TIMEDATA, JSON.stringify(timeData));
  },
  readPaySwitchStatus() {
    return JSON.parse(localStorage.getItem(PAYSWITCHSTATUS));
  },
  savePaySwitchStatus(paySwitchStatus) {
    localStorage.setItem(PAYSWITCHSTATUS, JSON.stringify(paySwitchStatus));
  },
  readTradeCondition() {
    return JSON.parse(Encrypt.get(localStorage.getItem(TRADECONDITION)));
  },
  saveTradeCondition(tradeCondition) {
    localStorage.setItem(
      TRADECONDITION,
      Encrypt.set(JSON.stringify(tradeCondition))
    );
  },
  readEntrustCondition() {
    return JSON.parse(Encrypt.get(localStorage.getItem(ENTRUSTCONDITION)));
  },
  saveEntrustCondition(entrustCondition) {
    localStorage.setItem(
      ENTRUSTCONDITION,
      Encrypt.set(JSON.stringify(entrustCondition))
    );
  },
  readProfitAndLossCondition() {
    return JSON.parse(
      Encrypt.get(localStorage.getItem(PROFITANDLOSSCONDITION))
    );
  },
  saveProfitAndLossCondition(profitAndLossCondition) {
    localStorage.setItem(
      PROFITANDLOSSCONDITION,
      Encrypt.set(JSON.stringify(profitAndLossCondition))
    );
  },
  readCreditCondition() {
    return JSON.parse(Encrypt.get(localStorage.getItem(CREDITCONDITION)));
  },
  saveCreditCondition(creditCondition) {
    localStorage.setItem(
      CREDITCONDITION,
      Encrypt.set(JSON.stringify(creditCondition))
    );
  },
  readStopCondition() {
    return JSON.parse(Encrypt.get(localStorage.getItem(STOPCONDITION)));
  },
  saveStopCondition(stopCondition) {
    localStorage.setItem(
      STOPCONDITION,
      Encrypt.set(JSON.stringify(stopCondition))
    );
  },
  readKeepAlive() {
    return JSON.parse(localStorage.getItem(KEEPALIVE));
  },
  saveKeepAlive(keepAlive) {
    localStorage.setItem(KEEPALIVE, JSON.stringify(keepAlive));
  },
  readTickData() {
    return JSON.parse(Encrypt.get(localStorage.getItem(TICKDATA)));
  },
  saveTickData(tickData) {
    localStorage.setItem(TICKDATA, Encrypt.set(JSON.stringify(tickData)));
  },
};
